import React from "react";

export function SubscriptionsPage() {
  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <div>
          <h1>Subscriptions</h1>
          <p className="admin-muted">
            Manage customer subscriptions and billing. Stripe integration is coming soon.
          </p>
        </div>
      </header>

      <div className="admin-page-content">
        <section style={{ marginBottom: "1.5rem" }}>
          <div className="admin-stats">
            <div className="admin-stat-card">
              <span className="material-symbols-outlined admin-stat-icon">payments</span>
              <div>
                <div className="admin-stat-value">—</div>
                <div className="admin-stat-label">Active subscriptions</div>
              </div>
            </div>
            <div className="admin-stat-card">
              <span className="material-symbols-outlined admin-stat-icon">trending_up</span>
              <div>
                <div className="admin-stat-value">—</div>
                <div className="admin-stat-label">Monthly recurring revenue</div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div
            className="admin-table-wrap"
            aria-label="Subscriptions table (placeholder until Stripe is connected)"
          >
            <table className="admin-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Plan</th>
                  <th>Status</th>
                  <th>Renews</th>
                  <th>Stripe Subscription ID</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={6}>
                    <p className="admin-muted">
                      Stripe has not been wired up yet. Once configured, this page will show
                      active subscriptions, allow upgrades/downgrades, and link directly to Stripe.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Future Stripe integration:
            - Add a useQuery hook here to load subscriptions from /api/admin/subscriptions.
            - Replace the placeholder row with mapped subscription data.
            - Add per-row actions for upgrade, cancel, and \"View in Stripe\".
        */}
      </div>
    </div>
  );
}

